import { useState } from "react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { WorkflowDraftLibrary } from "../workflowBuilder/WorkflowDraftLibrary";
import { WorkflowDraftDetails } from "../workflowBuilder/WorkflowDraftDetails";
import type { WorkflowLibraryView } from "../../components/NoteWorkflows/workflowLibraryTypes";

type Props = {
    organizationId: string;
    switching: boolean;
    onEdit: (draftId: string) => void;
    onCreate: () => void;
    renderLibrary?: (library: WorkflowLibraryView) => ReactNode;
};

/** Admin task definitions and delivery stay private to their creator. */
export function AdminScheduledWorkflowLibrary({ organizationId, switching, onEdit, onCreate, renderLibrary }: Props) {
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState<string | null>(null);
    return <section>
        {!renderLibrary && <p>{t("organizationWorkflowBuilder.scheduledHelp")}</p>}
        {selectedId ? <WorkflowDraftDetails key={`${organizationId}:${selectedId}`} draftId={selectedId} organizationId={organizationId}
            switching={switching} onBack={() => setSelectedId(null)} onEdit={() => onEdit(selectedId)} />
            : <WorkflowDraftLibrary organizationId={organizationId} onOpen={setSelectedId} onCreate={onCreate}
                renderLibrary={renderLibrary && (library => renderLibrary({ ...library, feedback: <>
                    {library.cards.length > 0 && <p>{t("organizationWorkflowBuilder.scheduledHelp")}</p>}
                    {library.feedback}
                </> }))}
                title={t("organizationWorkflowBuilder.scheduledTitle", { defaultValue: "My scheduled tasks" })} />}
    </section>;
}
